import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import watchStyle from "./styles";
import { Box, Typography, Button, Link, Modal } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useMutation } from "react-query";
import fetcher from "../../src/dataProvider";
import { STRAPI_API_URL } from "../../src/constant/appConstants";

const WatchVideos = (props) => {
  const [open, setOpen] = useState(false);
  const [ftrVideos, setFtrVideos] = useState([]);
  const [urlKey, setUrlKey] = useState();
  const handleOpen1 = (key) => {
    setUrlKey(key);
    setOpen(true);
  };
  const handleClose1 = () => setOpen(false);
  const Url = "https://www.youtube.com/embed/";

  var settings = {
    dots: false,
    arrow: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const { mutate: fanTigerWatchvideos } = useMutation(
    (data) =>
      fetcher.get(`${STRAPI_API_URL}/fantiger-videos`, {
        data,
      }),
    {
      onSuccess: (res) => {
        setFtrVideos(res.data);
      },
      onError: (error) => {
        console.log("#########", error);
      },
    }
  );

  useEffect(() => {
    fanTigerWatchvideos({});
  }, []);
  return (
    <Box sx={watchStyle.watchSection}>
      {ftrVideos.length > 0 && (
        <>
          <Box sx={watchStyle.firstWatchBox}>
            <Typography variant="h1" sx={watchStyle.watchTitleH1}>
              Watch Videos
            </Typography>
            <Typography component="p" sx={watchStyle.watchSubTitle}>
              For more info
            </Typography>
          </Box>
          <Box
            sx={{
              ...watchStyle.videoSliderContainer,
            }}
          >
            <Slider {...settings}>
              {ftrVideos.map((value, key) => {
                return (
                  <div key={key}>
                    {/* <Box sx={watchStyle.watchBox} key={key}>
                                                <Box onClick={() =>handleOpen1(value.attributes?.embed_key)}>
                                                    <Box sx={watchStyle.videoBgContainer}>
                                                        <Box component="img" src={value.attributes?.thumbnail_image_url}/>
                                                    </Box>
                                                    <Typography variant='h1' sx={{cursor:'pointer', fontSize:'24px', color:'#FFF', marginTop: "15px"}}>{value.attributes?.title}</Typography>
                                                </Box>
                                            </Box> */}
                    <div
                      style={{
                        padding: "0 7px",
                      }}
                    >
                      <iframe
                        width="100%"
                        height="320px"
                        src={Url + value.attributes?.embed_key}
                        title="What is NFT?"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        controls="true"
                      ></iframe>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </Box>
        </>
      )}
      {/* <Modal open={open} onClick={handleClose1}>
            <Box sx={watchStyle.modalVideo}>
                <iframe width="853" height="480" src={Url+ urlKey} title="What is NFT?" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </Box>
        </Modal> */}
    </Box>
  );
};

export default WatchVideos;
